import TextRead from './TextRead/TextRead';
import TextSave from './TextSave/TextSave';
import { types } from './types';

//Enter the switch according to the incoming action names, it renders.
function Actions(action, showAlert, variables, setOpenVariable, automId, automVersionId, getVariables) {
    switch (action.actionName) {
        case types.TEXTREAD: return <TextRead action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automVersionId={automVersionId} automId={automId} getVariables={getVariables} />;
        case types.TEXTSAVE: return <TextSave action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} automId={automId} />;
        default: break;
    }
}
export default Actions;